import { z } from "zod";

export const create = z.object({
  name: z.string().min(1, "Required"),
  description: z.string().nullish(),
  testSpecIds: z.number().array().prefault([]),
});

export const update = create.extend({ id: z.number() });
